module.exports = __webpack_public_path__ + "static/img/logo_slogan_h5_zh.a993885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo_slogan_h5_zh.png
// module id = MQCC
// module chunks = 34